$('.village-list__filter').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.village-list__top').toggleClass('filter-open');
});

$('.village-list__top-list a').on('click', function (e) {
    e.preventDefault();
    $('.village-list__top-list a').removeClass('current');
    $(this).addClass('current');
    $('.village-list__top').removeClass('filter-open');

    if ($(this).data('sort') != 'all') {
        $('.village-list__grid .village-item').hide();
        $('.village-list__grid .village-item[data-sort=' + $(this).data('sort') + ']').fadeIn();
        $('.village-list__top h2 span').show();
    } else {
        $('.village-list__grid .village-item').fadeIn();
        $('.village-list__top h2 span').hide();
    }

    $('.village-list__filter').text($(this).text());
});

$(document).mouseup(function (e) {
    var div = $(".village-list__top-list, .village-list__filter");
    if (!div.is(e.target)
        && div.has(e.target).length === 0) {
        $('.village-list__top').removeClass('filter-open');
    }
});

